import {
  Alert,
  Button,
  Card,
  CardBody,
  Select,
  SelectItem,
} from '@heroui/react';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setToken } from '@/patient-app-common/slices/authSlice';
import { useSetProcedureSetMutation } from '@/patient-app-common/api/procedureApi';
import { useAppSelector } from '@/redux/hooks';
import { ProcedureSets } from '@/patient-app-common/types/Procedure';

interface CareplanProps {
  procedureSets: ProcedureSets[];
}

export function Careplans({ procedureSets }: CareplanProps) {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const [setProcedureSet, { isLoading, isSuccess, isError }] =
    useSetProcedureSetMutation();

  const { token } = useAppSelector(({ auth }) => auth);
  const [selectedToken, setSelectedToken] = useState(token);

  const handleSubmit = async () => {
    if (selectedToken) {
      dispatch(setToken(selectedToken));
      await setProcedureSet({});
    }
  };

  return (
    <div className="space-y-4">
      <Alert
        className="max-w-lg"
        color="danger"
        description={t('common.error.server')}
        hideIconWrapper
        isVisible={isError}
        variant="faded"
      />
      <Alert
        className="max-w-lg"
        color="success"
        description={t('common.text.update_success')}
        hideIconWrapper
        isVisible={isSuccess}
        variant="faded"
      />
      <div className="space-x-4 pb-4">
        <Card className="max-w-xs mb-4" shadow="none">
          <CardBody className="p-0.5">
            <Select
              label={t('common.text.program')}
              defaultSelectedKeys={token ? [token] : []}
              onChange={(e) => setSelectedToken(e.target.value)}
              variant="bordered"
            >
              {procedureSets.map((set) => {
                let label = set.procedureSetName;

                if (set.surgeryDate) {
                  label += ` (${dayjs(set.surgeryDate).format('MMM D YYYY')})`;
                }

                return <SelectItem key={set.token}>{label}</SelectItem>;
              })}
            </Select>
          </CardBody>
        </Card>
        <Button color="primary" onPress={handleSubmit} isLoading={isLoading}>
          {t('common.action.save')}
        </Button>
      </div>
    </div>
  );
}
